import type ChangeOwnPasswordProperties from './ChangeOwnPassword.properties.ts';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { toastOptions } from '../../tools/helpers/ToastHelper.ts';
import { useTranslation } from 'react-i18next';
import { useChangeOwnPassword } from '../../apis/user-profile/useChangeOwnPassword.ts';
import { extractMessageFromApi } from '../../tools/helpers/MessageHelper.ts';
import { isPasswordLongEnough } from '../../tools/helpers/PasswordPolicy.ts';

export const useChangeOwnPasswordController = (props: ChangeOwnPasswordProperties) => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [repeatPassword, setRepeatPassword] = useState<string>('');

  const { mutate, isPending } = useChangeOwnPassword();

  const handleSave = () => {
    mutate(
      {
        currentPassword,
        newPassword: newPassword.trim(),
      },
      {
        onSuccess: (data) => {
          toast.success(extractMessageFromApi(data, t).message, toastOptions);
          props.handleDialogCloseClick();
        },
      }
    );
  };

  const enableSaveButton = () => {
    return (
      currentPassword.trim().length > 0 &&
      isPasswordLongEnough(newPassword) &&
      newPassword === repeatPassword
    );
  };

  return {
    loading: isPending,
    handleSave,
    enableSaveButton,
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    repeatPassword,
    setRepeatPassword,
  };
};
